import { useMemo, useCallback } from 'react';
import { Select } from 'foundations-components/transitional/components/Select';
import { useGetAllAssignedContentForPortalQuery } from '../../../../../__generated__/chirp/com/hubspot/learning/center/credentials/rpc/AssignedContentChirpService.hooks';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ButtonContent = ({
  count
}) => {
  if (count === 0) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.myTeam.filters.content.noneSelectedLabel"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.myTeam.filters.content.someSelectedLabel",
    options: {
      count
    }
  });
};
const ContentFilter = ({
  onChange,
  selectedContentIds
}) => {
  const {
    data,
    loading
  } = useGetAllAssignedContentForPortalQuery();
  const options = useMemo(() => {
    return data === null || data === void 0 ? void 0 : data.results.map(content => ({
      text: content.contentName,
      value: content.contentId.toString()
    }));
  }, [data === null || data === void 0 ? void 0 : data.results]);
  const handleChange = useCallback(event => {
    const selectedValues = event.target.value.map(Number);
    onChange(selectedValues);
  }, [onChange]);
  return /*#__PURE__*/_jsx(Select, {
    ButtonContent: ButtonContent,
    anchorType: "button",
    buttonContentProps: {
      count: selectedContentIds.length
    },
    buttonUse: "transparent",
    isLoading: loading,
    menuWidth: 350,
    minimumSearchCount: 1,
    multi: true,
    onChange: handleChange,
    options: options,
    value: selectedContentIds.map(String)
  });
};
export default ContentFilter;